module.exports = __webpack_public_path__ + "assets/img/weix.c09869b6.png";